module.exports = __webpack_public_path__ + "static/media/scoreCard.b65fe5d3.svg";